<main>
  <form class="container-fluid main-container my-5" *ngIf="user && organization" [formGroup]="organizationForm">
    <a class="text-decoration-none" routerLink="../">
      <i class="bi bi-arrow-left me-2"></i>Vorige pagina
    </a>
    <h1 class="subtitle mt-5">Contactgegevens wijzigen</h1>
    <hr>
    <div class="alert alert-success" role="alert" *ngIf="formSubmitted">
      Contactgegevens succesvol gewijzigd.
    </div>

    <label for="organizationContactName" class="form-label required-input">Naam contactpersoon</label>
    <input type="text" class="form-control form-input" formControlName="organizationContactName" id="organizationContactName" [value]="organization.contactName">
    <div class="text-danger mt-1" [ngClass]="{'visible' : (organizationContactName?.dirty && organizationContactName?.touched) && organizationContactName?.errors}">
      <span *ngIf="organizationContactName?.errors?.['required']">Dit veld is vereist</span>
      <span *ngIf="organizationContactName?.errors?.['minlength']">Naam contactpersoon moet minimaal 2 karakters lang zijn</span>
      <span *ngIf="organizationContactName?.errors?.['maxlength']">Naam contactpersoon mag maximaal 50 karakters lang zijn</span>
    </div>
    <label for="organizationContactPhone" class="form-label required-input mt-3">Telefoonnummer</label>
    <input type="text" class="form-control form-input" formControlName="organizationContactPhone" id="organizationContactPhone" [value]="organization.contactPhone">
    <div class="text-danger mt-1" [ngClass]="{'visible' : (organizationContactPhone?.dirty && organizationContactPhone?.touched) && organizationContactPhone?.errors}">
      <span *ngIf="organizationContactPhone?.errors?.['required']">Dit veld is vereist</span>
      <span *ngIf="organizationContactPhone?.errors?.['pattern']">Geen geldig telefoonnummer</span>
    </div>
    <p class="form-text text-md-end mt-2 url">*Verplichte velden</p>

    <div class="text-center">
      <button type="submit" class="btn btn-primary mb-4 btn-register m-auto mt-5" (click)="updateOrganization()">Opslaan</button>
    </div>
  </form>
</main>
